import { useState } from 'react';
import { useMe } from '../auth/useMe';
import { RowMenu } from '../ui/RowMenu';
import { canManageSettings } from './access';
import { ChecklistPresetsSettings } from './ChecklistPresetsSettings';
import { pointsLabel, usePresets, type ChecklistPreset } from './checklists';
import { SettingsDialog } from './SettingsDialog';

/** The gear of the checklists (rule 9): opens the lists of the settings in a dialog, for whoever may change them. */
export function PresetsGear() {
  const { me } = useMe();
  const [open, setOpen] = useState(false);
  if (!me || !canManageSettings(me).checklists) return null;
  return (
    <>
      <RowMenu icon="gear" label="Ustawienia: listy kontrolne" featureId="planning.checklist_presets" actions={[{ label: 'Zarządzaj listami kontrolnymi…', onSelect: () => setOpen(true) }]} />
      {open && (
        <SettingsDialog title="Listy kontrolne" onClose={() => setOpen(false)}>
          <ChecklistPresetsSettings me={me} heading={false} />
        </SettingsDialog>
      )}
    </>
  );
}

/** Wizard: the checklists of the settings to add to the new event, as ticks. */
export function PresetPicker({ value, onChange }: { value: string[]; onChange: (ids: string[]) => void }) {
  const presets: ChecklistPreset[] = usePresets().data?.presets ?? [];
  return (
    <fieldset className="preset-picker" data-feature-id="planning.checklist_presets">
      <legend className="visually-hidden">Listy kontrolne</legend>
      <div className="field-head">
        <span className="field-label" aria-hidden="true">
          Listy kontrolne
        </span>
        <PresetsGear />
      </div>
      {presets.length === 0 && <p className="hint">Nie ma jeszcze gotowych list. Dodasz je trybikiem ⚙ obok albo w Administracja → Ustawienia firmy.</p>}
      {presets.map((p) => (
        <label key={p.id} className="check">
          <input type="checkbox" checked={value.includes(p.id)} onChange={(e) => onChange(e.target.checked ? [...value, p.id] : value.filter((x) => x !== p.id))} />
          <span>
            {p.name} <span className="muted">({pointsLabel(p.items.length)})</span>
          </span>
        </label>
      ))}
      {presets.length > 0 && <p className="hint field-hint">Punkty dołączą do listy kontrolnej wydarzenia (także tej z szablonu), bez powtórzeń.</p>}
    </fieldset>
  );
}
